import { useEffect, useState } from 'react';
import { CommonHelper } from 'src/utils/commonHelper';
import ThreadsPostPreview from './threads-post-preview.component';

const ThreadsPreviewOrganize = ({ postType, previewData, profileId }) => {
  const [data, setData] = useState({});
  useEffect(() => {
    if (!previewData || !profileId) return;
    let data = previewData[profileId].data;
    for (var i = 0; i < data.length; i++) {
      if (data[i].post_type === postType) {
        data[i].media_data = CommonHelper.ProcessMediaUrl(data[i].media_url);
        setData(data[i]);
      }
    }
  }, [postType, previewData, profileId]);

  return <>{data && data?.post_type === 'post' && <ThreadsPostPreview data={data} />}</>;
};

export default ThreadsPreviewOrganize;
